// extracted by mini-css-extract-plugin
export var filterIncDec = "_8z-0";
export var leftBorder = "_8z-1";
export var rightBorder = "_8z-2";
export var stringInput = "_8z-3";